import React from "react"
import { Modal, Button, Flex } from "antd"
import styles from "./index.module.css"
import PropTypes from "prop-types"
import WarningOutlinedWithBg from "ui/WarningOutlinedWithBg"
import { useDevice } from "hooks/useDevice"
import CustomDrawer from "ui/Drawer"

export const DeleteConfirmation = ({
  visible,
  onCancel,
  onConfirm,
  title,
  content,
  confirmText = "Delete",
  cancelText = "Cancel",
  loading = false
}) => {
  const { isMobile } = useDevice()

  const handleClose = () => {
    onCancel()
  }

  const handleDrawerOpenChange = (nextOpen) => {
    if (!nextOpen) {
      handleClose()
    }
  }

  const contentNode = (
    <div className={styles.modalContent}>
      <Flex justify="center" align="center" className="mb-4">
        <WarningOutlinedWithBg />
      </Flex>
      {!isMobile && <h3 className={styles.modalTitle}>{title}</h3>}
      <div className={styles.modalText}>{content}</div>
      <Flex align="center" gap={10} className={styles.buttonGroup}>
        <Button onClick={handleClose} color="primary" variant="outlined" disabled={loading}>
          {cancelText}
        </Button>
        <Button type="primary" onClick={onConfirm} loading={loading} danger>
          {confirmText}
        </Button>
      </Flex>
    </div>
  )

  const Container = isMobile ? CustomDrawer : Modal
  const containerProps = isMobile
    ? {
        open: visible,
        setOpen: handleDrawerOpenChange,
        title
      }
    : {
        open: visible,
        onCancel: handleClose,
        footer: null,
        centered: true,
        className: styles.deleteModal,
        width: 520,
        maskClosable: false
      }

  return <Container {...containerProps}>{contentNode}</Container>
}

DeleteConfirmation.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  content: PropTypes.node,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  loading: PropTypes.bool
}

export default DeleteConfirmation
